import http from './http';

export default {
  all() {
    return http().get(`/v2/custom_fields`);
  },
  get(id) {
    return http().get(`/v2/custom_fields/${id}`);
  },
  create(data) {
    return http().post(`/v2/custom_fields`, data);
  },
  update(data) {
    return http().put(`/v2/custom_fields/${data.id}`, data);
  },
  delete(id) {
    return http().delete(`/v2/custom_fields/${id}`);
  },
}
